import React, { useEffect } from 'react';
// import Aos from "aos";
// import "aos/dist/aos.css";
import classes from './Projects.module.css';
import Project from './PersonalProjects/Project';
import { ProjectsData } from '../../Assets/Data/ProjectsData';
import OpenSource from './OpenSource/OpenSource';
import Header from '../UI/Header/Header';

const Projects = () => {
  // useEffect(() => {
  //     Aos.init({duration:1000})
  // }, [])

  return (
    <>
      <div className={classes['project-section']} id="projects">
        <div className={classes.heading}>
          <Header header="PROJECTS" styles={classes.heading} />
        </div>
        <div className={classes.projects}>
          {ProjectsData.map((project, index) => {
            return <Project project={project} key={index} />;
          })}
        </div>
        <OpenSource />
      </div>
    </>
  );
};

export default Projects;
